import { faCheck, faCheckCircle, faX } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { UserRecipePhoto } from '@/api/types'
import { Button } from '@/components/Button'
import { Flex } from '@/components/Flex'
import { Dialog, Modal } from '@/components/Modal'

type Props = {
  previewUrl: string
  photo: UserRecipePhoto
  onApprove: () => void
  onReject: () => void
  onSetAsCover: () => void
}

export default function RecipePhotoFullscreen({
  photo,
  previewUrl,
  onApprove,
  onReject,
  onSetAsCover,
}: Props) {
  const { t } = useTranslation()

  return (
    <Modal className="RecipePhotoFullscreen-modal">
      <Dialog>
        {({ close }) => (
          <div className="RecipePhotoFullscreen">
            <Button
              className="RecipePhotoFullscreen-close"
              aria-label="Close"
              onPress={close}
              autoFocus>
              <span aria-hidden="true">&times;</span>
            </Button>

            {photo.photoSource === 'AI_GENERATED' && (
              <div className="RecipePhotoItem-ai-badge">AI</div>
            )}

            <img className="RecipePhotoFullscreen-preview" src={previewUrl} />

            <div className="RecipePhotoFullscreen-info">
              {photo.latestModerationStatus === 'NOT_MODERATED' && (
                <Flex gap={4}>
                  <Button
                    variant="negative"
                    onPress={() => {
                      if (confirm(t('photos.confirmReject'))) {
                        close()
                        onReject()
                      }
                    }}>
                    <FontAwesomeIcon icon={faX} />
                    {t('photos.reject')}
                  </Button>
                  <Button
                    onPress={() => {
                      close()
                      onApprove()
                    }}>
                    <FontAwesomeIcon icon={faCheck} />
                    {t('photos.approve')}
                  </Button>
                  <Button
                    style={{ gap: 4, display: 'flex', alignItems: 'center' }}
                    onPress={() => {
                      close()
                      onSetAsCover()
                    }}>
                    <FontAwesomeIcon icon={faCheckCircle} color="#62A3FF" />
                    {t('photos.setAsCover')}
                  </Button>
                </Flex>
              )}
            </div>
          </div>
        )}
      </Dialog>
    </Modal>
  )
}
